import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import SearchBar from "../../components/SearchBar";
import {
  Button,
  Card,
  ListGroup,
  Modal,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  getVariable,
  removeVariable,
  setVariable,
} from "../../Helpers/Session";
import "./PlaceOrder.css";
import apiRequest from "../../Api";
import ReactToast from "../../components/Toast";

const PlaceOrder = () => {
  const initialCart = getVariable("cartItems", true) || [];
  const [orderItems, setOrderItems] = useState(initialCart);
  const [showModal, setShowModal] = useState(false);
  const [orderDate, setOrderDate] = useState(new Date());
  console.log(orderDate);
  let selItems = getVariable("selItems", true);  
  const navigate = useNavigate();
  const orderLimit = getVariable("order_limit") || {
    total_limit: 1000,
    order_placed: 0,
  };
  const [dateError, setDateError] = useState("");
  const curSymbol = getVariable("curSymbol", true);

  const updateQuantity = (id, amount) => {
    let newgrandTotal = 0;
    let newQytTotal = 0;
    const updatedItems = orderItems.map((value) => {
      console.log(typeof value.cartQuantity);
      if (value.pkid === id) {
        const min_buy_qty = parseFloat(value?.fMinBuyQty) || 1;
        const existing_qty = parseFloat(value.cartQuantity);
        value.cartQuantity = Math.max(min_buy_qty, existing_qty + amount);
        
        value.cartQuantity = (value.cartQuantity).toFixed(3);
      }
      newgrandTotal +=
        parseFloat(value.fUnitRate) * parseFloat(value.cartQuantity);
        newQytTotal += parseFloat(value.cartQuantity);
        return value;
      });

    setOrderItems(updatedItems);
    setVariable("cartItems", updatedItems, true);
  };
  
  const handleQuantityChange = (e, pkid) => {
    let value = e.target.value;
  
    // allow only numbers with up to 3 decimal places
    if (/^\d*\.?\d{0,3}$/.test(value)) {
      const floatValue = parseFloat(value);
  
      if (!isNaN(floatValue) && floatValue > 0) {
        const updatedItems = [...orderItems];
        const itemIndex = updatedItems.findIndex((item) => item.pkid === pkid);
  
        if (itemIndex > -1) {
          // Round to 3 decimals
          updatedItems[itemIndex].cartQuantity = parseFloat(floatValue.toFixed(3));
          setOrderItems(updatedItems);
          setVariable("cartItems", updatedItems);
        }
      }
    }
  };

  const removeItem = async (id) => {
    // Find the index of the item in the selected items list
    let indexOfItem = selItems?.indexOf(id.toString());

    if (indexOfItem > -1) {
      selItems?.splice(indexOfItem, 1);

      const updateItems = orderItems.filter(
        (row) => row.pkid !== id.toString()
      );

      setOrderItems(updateItems);
      setVariable("cartItems", updateItems, true);
      setVariable("selItems", selItems, true);
    }
  };

  const calculateItemTax = (item) => {
    return (
      (item.cartQuantity *
        parseFloat(item.fUnitRate) *
        parseFloat(item.fIGST)) /
      100
    ).toFixed(2);
  };

  const calculateItemNetAmount = (item) => {
    const totalAmount = item.cartQuantity * parseFloat(item.fUnitRate);
    const taxAmount = parseFloat(calculateItemTax(item));
    return (totalAmount + taxAmount).toFixed(2);
  };

  const calculateTotal = () => {
    return orderItems
      .reduce(
        (acc, item) => acc + item.cartQuantity * parseFloat(item.fUnitRate),
        0
      )
      .toFixed(2);
  };

  const calculateTax = () => {
    return orderItems
      .reduce(
        (acc, item) =>
          acc +
          (item.cartQuantity *
            parseFloat(item.fUnitRate) *
            parseFloat(item.fIGST)) /
            100,
        0
      )
      .toFixed(2);
  };

  const saveOrderData = async (e) => {
    if (!orderDate) {
      setDateError("Please select date");
      return;
    }
    e.preventDefault();
    try {
      let baseUrl = process.env.REACT_APP_API_BASE;
      const apiSetting = {
        method: "POST",
        apiParams: {
          entry_type: "mobile",
          product_data: getVariable("cartItems", true),
          sele_date: moment(orderDate).format("YYYY-MM-DD"),
        },
      };
      const orderData = await apiRequest(
        `${baseUrl}OrderPanelApi/saveOrderData`,
        apiSetting
      );
      if (orderData.data && orderData.data.success == 1) {
        setVariable(
          "order_limit",
          {
            ...orderLimit,
            order_placed: orderData?.data?.order_placed_sofar || 0,
          },
          true
        );
        removeVariable("selItems", true);
        removeVariable("cartItems", true);
        ReactToast("success", orderData.data.message);
        navigate("/thank-you");
      } else {
        throw new Error(orderData.data.message);
      }
    } catch (error) {
      ReactToast({ type: "error", message: error.message });
    } finally {
    }
  };

  const onDateChange = (date) => {
    setDateError("");
    setOrderDate(date);
  };

  let isNotAllowPlaceOrder =
    parseInt(orderLimit?.total_limit || 1000) <=
    parseInt(orderLimit?.order_placed || 0);

  const onSearch = (event) => {
    let searchTerm = event.target.value.trim().toLowerCase(); // Get and normalize the search term

    if (searchTerm) {
      // If search term exists, filter the cartItems based on itemTitle
      const filteredItems = initialCart.filter((row) =>
        row.itemTitle.toLowerCase().includes(searchTerm)
      );
      setOrderItems(filteredItems);
    } else {
      // If no search term, display all items
      setOrderItems(initialCart);
    }
  };

  return (
    <div className="place-order-container">
      <div className="d-flex w-100 justify-content-between mb-2">
        <div className="w-100">
          <SearchBar onSearch={onSearch} />
        </div>
        <div className="fr backtoitemlist">
          <NavLink to="/itemlist">
            <i className="mdi mdi-24px mdi-arrow-left-bold-circle"></i>
          </NavLink>
        </div>
      </div>
      <Card className="item-list">
        <Card.Body>
          {orderItems.length > 0 ? (
            <ListGroup variant="flush">
              {orderItems.map((item) => (
                <ListGroup.Item
                  key={item.pkid} // Use pkid for uniqueness
                  className="d-flex flex-column flex-md-row justify-content-between align-items-md-center"
                >
                  <div className="d-flex align-items-center product-row">
                    <img
                      src={item.product_image} // Assuming product_image contains the image URL
                      alt={item.itemTitle}
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        marginRight: "15px",
                      }}
                    />
                    <div>
                      <strong>{item.itemTitle}</strong>
                      <p className="mb-1">
                        {curSymbol}
                        <small className="unit-rate-text">
                          {item.fUnitRate}
                        </small>{" "}
                        <small className="text-muted ">
                          / {item?.unitMasterName?.toLowerCase()}{" "}
                          {parseFloat(item?.fIGST) > 0 && (
                            <OverlayTrigger
                              trigger="click"
                              placement="top"
                              rootClose
                              overlay={
                                <Popover id={`popover-${item.pkid}`}>
                                  <Popover.Body>
                                    <small>
                                      Calculated Tax:{" "}
                                      <strong className="text-muted">
                                        {curSymbol} {calculateItemTax(item)}
                                      </strong>
                                    </small>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <small
                                className="text-danger"
                                style={{ cursor: "pointer" }}
                              >
                                ({item.fIGST}% Tax)
                              </small>
                            </OverlayTrigger>
                          )}
                        </small>
                      </p>
                    </div>
                  </div>

                  <div className="item-summary d-flex align-items-end justify-content-end mt-3">
                    <div className="item-actions">
                      <Button
                        size="sm"
                        className="icon-btn"
                        onClick={() => removeItem(item.pkid)}
                      >
                        <FaTrash />
                      </Button>
                      <div className="quantity-container">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="quantity-btn"
                          
                             onClick={() =>{ 
                          const min_buy_qty = parseFloat(item?.fMinBuyQty) || 1
                          updateQuantity(item.pkid, -1*min_buy_qty)}}
                        >
                          -
                        </Button>
                        <input
                          type="number"
                          step="0.001"
                          min="0"
                          className="mx-2 quantity-input"
                          value={item.cartQuantity}
                          readOnly
                          onChange={(e) => handleQuantityChange(e, item.pkid)}
                        />
                        <Button
                          variant="outline-secondary"
                          size="sm"                          
                          className="quantity-btn"
                          
                          onClick={() =>{ 
                          const min_buy_qty = parseFloat(item?.fMinBuyQty) || 1
                          updateQuantity(item.pkid, min_buy_qty)}}
                        >
                          +
                        </Button>
                      </div>
                      <div className="gross-amount d-flex flex-column justify-content-end align-items-end text-success">
                        {/* {calculateItemTax(item) > 0 && (
                          <small className="text-muted  tax-amount">
                            {curSymbol}
                            <b>{calculateItemTax(item)}</b>{" "}
                          </small>
                        )} */}
                        <large>
                          {curSymbol}
                          <b>{calculateItemNetAmount(item)}</b>
                        </large>
                      </div>
                    </div>
                  </div>
                </ListGroup.Item>
              ))}
            </ListGroup>
          ) : (
            <p className="text-center text-muted place-content-center h-100">
              Your cart is empty.
            </p>
          )}
        </Card.Body>
      </Card>
      {orderItems.length > 0 && (
        <Card className="mt-2 summary-container">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-md-center summary-row">
              <span>Subtotal:</span>
              <span>
                {" "}
                {curSymbol}
                {calculateTotal()}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-md-center text-danger summary-row">
              <span>Tax:</span>
              <span>
                {" "}
                {curSymbol}
                {calculateTax()}
              </span>
            </div>
            <div className="d-flex justify-content-between align-items-md-center summary-row">
              <strong>Total:</strong>
              <strong>
                {curSymbol}{" "}
                {(
                  parseFloat(calculateTotal()) + parseFloat(calculateTax())
                ).toFixed(2)}
              </strong>
            </div>
            <div className="d-flex justify-content-end align-items-md-center pt-2">
              <Button
                className="place-order-btn bg-green-400"
                onClick={() => setShowModal(true)}
              >
                Place Order
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Order Date Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          {!isNotAllowPlaceOrder && (
            <Modal.Title size="sm">Select Order Date</Modal.Title>
          )}
        </Modal.Header>
        <Modal.Body className="order-date">
          {isNotAllowPlaceOrder ? (
            "You have reached the maximum order limit for today. You can place a new order tomorrow."
          ) : (
            <DatePicker
              selected={orderDate}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => onDateChange(date)}
              className="form-control "
            />
          )}
          {dateError && <p className="text-danger mt-2">{dateError}</p>}
        </Modal.Body>
        {!isNotAllowPlaceOrder && (
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button onClick={saveOrderData}>Submit</Button>
          </Modal.Footer>
        )}
      </Modal>
    </div>
  );
};

export default PlaceOrder;
